import { useState, useEffect } from 'react';

let timerId;

export const useDebounce = ({ requiredLength = 2, delay = 500 }) => {
    const [inputValue, setInputValue] = useState('');

    const [delayedInputValue, setDelayedInputValue] = useState('');

    useEffect(() => {
        if (inputValue?.length > requiredLength || inputValue === null) {

            clearTimeout(timerId);

            timerId = setTimeout(() => {
                setDelayedInputValue(inputValue);
            }, delay);
        }
    }, [inputValue]);

    return {
        inputValue,
        setInputValue,
        delayedInputValue,
        setDelayedInputValue
    };
};
